import { render } from "./ReleaseConfirmModal.vue?vue&type=template&id=a1038cba"
import script from "./ReleaseConfirmModal.vue?vue&type=script&lang=js"
export * from "./ReleaseConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__